import React from 'react'
import { Form, } from 'semantic-ui-react'

import ComponentLoader from '~/components/component-loader';
import { StyledForm } from '~/components/form'
import { createFormProps, createCheckFormProps, Errors } from "~/components/contacts";

import logic from './logic'
import loadable from "@loadable/component";

const CountrySelect = loadable(() => import(/* webpackChunkName: "countries" */ '~/components/form/countries'), {fallback: <ComponentLoader />});
const Phone = loadable(() => import(/* webpackChunkName: "phone" */ '~/components/form/phone'), {fallback: <ComponentLoader />});

@logic
export default class ContactForm extends React.PureComponent {
  handleSubmit = () => {
    const { submit } = this.props.actions;

    submit();
  };

  render() {
    const { contactFields, values, submitErrors, isSubmitting, formLoading } = this.props;
    const { setValue, submit } = this.props.actions;

    const getFormProps = createFormProps(values, setValue, submitErrors);
    const getCheckFormProps = createCheckFormProps(values, setValue, submitErrors);
    return (
      <StyledForm error={ !!submitErrors } loading={ isSubmitting || formLoading} onSubmit={ this.handleSubmit }>
        { contactFields.email ?
          <Form.Input
            fluid
            {...getFormProps('email')}
          />
        : null }

        { contactFields.subscribe_to_newsletter ?
          <Form.Checkbox
            {...getCheckFormProps('subscribe_to_newsletter')}
          />
        : null }

        <Form.Group widths='equal'>
          { contactFields.first_name ?
            <Form.Input
              fluid
              {...getFormProps('first_name')}
            />
          : null }
          { contactFields.last_name ?
            <Form.Input
              fluid
              {...getFormProps('last_name')}
            />
          : null }
        </Form.Group>

        { contactFields.phone ?
          <Form.Input
            fluid
            control={ Phone }
            {...getFormProps('phone')}
          />
        : null }

        { contactFields.company_billing ?
          <Form.Checkbox
            {...getCheckFormProps('company_billing')}
          />
        : null }
        { contactFields.company ?
          <Form.Input
            fluid
            {...getFormProps('company')}
          />
        : null }

        { contactFields.address ?
          <div>
            <Form.Group widths='equal'>
              { contactFields.address.address ?
                <Form.Input
                  fluid
                  {...getFormProps('address.address')}
                />
              : null }
              { contactFields.address.address_line_2 ?
                <Form.Input
                  fluid
                  {...getFormProps('address.address_line_2')}
                />
              : null }
            </Form.Group>

            <Form.Group widths={ 16 }>
              { contactFields.address.city ?
                <Form.Input
                  width={ 12 }
                  fluid
                  {...getFormProps('address.city')}
                />
              : null }
              { contactFields.address.postal_code ?
                <Form.Input
                  width={ 4 }
                  fluid
                  {...getFormProps('address.postal_code')}
                />
              : null }
            </Form.Group>

            <Form.Group widths='equal'>
              { contactFields.address.state ?
                <Form.Input
                  fluid
                  {...getFormProps('address.state')}
                />
              : null }
              { contactFields.address.country ?
                <Form.Field
                  fluid
                  control={ CountrySelect }
                  {...getFormProps('address.country')}
                />
              : null }
            </Form.Group>
          </div>
        : null }
        <Errors errors={ submitErrors} />
        {/* This is required so enter to submit works for this form */}
        <Form.Button content='Submit' style={{display: 'none'}} />
      </StyledForm>
    )
  }
}
